// extracted by mini-css-extract-plugin
export default {"iframe":"PaymentsView_iframe__uKJYB"};